function applyStylesOnHover(target, styles = {}) {
  Object.assign(target.style, styles);
}

function handleHoverEvents(elements, getTarget, hoverStyles, resetStyles) {
  elements.forEach(element => {
    element.addEventListener('mouseenter', () => {
      const target = getTarget(element);
      if (target) applyStylesOnHover(target, hoverStyles);
    });

    element.addEventListener('mouseleave', () => {
      const target = getTarget(element);
      if (target) applyStylesOnHover(target, resetStyles);
    });
  });
}

const hoverStyles = {
  opacity: '0.3',
};

const resetStyles = {
  opacity: '1',
};


